/* eslint-disable jsx-a11y/control-has-associated-label */
import React, { FC, HTMLProps } from 'react';
import classNames from 'classnames';
import { ReactComponent as CloseIcon } from 'assets/icons_3/x-close.svg';
import styles from './Alert.module.scss';

interface IAlertProps extends Omit<HTMLProps<HTMLDivElement>, 'size'> {
  size?: 'sm' | 'md'
  variant?: 'danger' | 'success' | 'primary' | 'warning';
  Icon?: React.ReactNode;
  message: string
  dismissible?: boolean;
  show?: boolean;
  onClose?: () => void;
}

const Alert: FC<IAlertProps> = ({
  className,
  size = 'md',
  variant = 'danger',
  Icon,
  message,
  dismissible = false,
  show = true,
  onClose,
  children, ...props
}) => {
  if (!show) return null;
  return (
    <div
      className={classNames(className, styles.alert, styles[size], styles[variant])}
      {...props}
    >
      {dismissible && (
        <button type="button" className={styles.closeBtn} onClick={onClose}>
          <CloseIcon />
        </button>
      )}
      {Icon && (
      <span className={styles.icon}>
        {Icon}
      </span>
      )}
      <span>{message}</span>
    </div>
  );
};

export default Alert;
